import { render, staticRenderFns } from "./TopicDetail.vue?vue&type=template&id=350864e8&scoped=true&"
import script from "./TopicDetail.vue?vue&type=script&lang=ts&"
export * from "./TopicDetail.vue?vue&type=script&lang=ts&"
import style0 from "./TopicDetail.vue?vue&type=style&index=0&id=350864e8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "350864e8",
  null
  
)

export default component.exports